// extracted by mini-css-extract-plugin
export var searchHeader = "_7j-0";
export var searchHeaderDark = "_7j-1";